// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DynProperty } from '../../../DynProperty';
export var InputParameterType;
(function (InputParameterType) {
    InputParameterType[InputParameterType["STRING"] = DynProperty.STRING] = "STRING";
    InputParameterType[InputParameterType["INTEGER"] = DynProperty.INTEGER] = "INTEGER";
    InputParameterType[InputParameterType["DOUBLE"] = DynProperty.DOUBLE] = "DOUBLE";
    InputParameterType[InputParameterType["COMBOBOX"] = DynProperty.COMBOBOX] = "COMBOBOX";
    InputParameterType[InputParameterType["BOOLEAN"] = DynProperty.BOOLEAN] = "BOOLEAN";
    InputParameterType[InputParameterType["INSTRUMENT"] = DynProperty.INSTRUMENT] = "INSTRUMENT";
    InputParameterType[InputParameterType["ACCOUNT"] = DynProperty.ACCOUNT] = "ACCOUNT";
    InputParameterType[InputParameterType["SEPARATOR"] = DynProperty.GROUP_SEPARATOR] = "SEPARATOR";
    InputParameterType[InputParameterType["RANGECONTROL"] = DynProperty.RANGECONTROL] = "RANGECONTROL";
})(InputParameterType || (InputParameterType = {}));
